<template>
  <v-footer absolute color="greend" dark>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" lg="10" xl="8" offset-lg="1" offset-xl="2">
          <v-card class="mb-6" color="rgba(0, 0, 0, 0)" flat>
            <v-card-title class="pa-0 ma-0 text-subtitle-1"
              >&copy; {{ new Date().getFullYear() }} Heberlein
              Kräutertee</v-card-title
            >
            <v-card-text class="pa-0 ma-0 text-body-2 font-weight-light"
              >Kräutertee aus kontrolliert biologischem Anbau
              (DE-ÖKO-006)</v-card-text
            >
            <v-card-text class="pa-0 ma-0 text-body-2 font-weight-light"
              ><router-link to="/impressum" class="white--text"
                >Impressum, AGB & Datenschutz</router-link
              ></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped></style>
